import {
  type ToggleViewControlPayload,
  type ViewControlPayload,
  type ZoomControlPayload,
} from '@bizzdesign/modeler/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const frameViewControlToolbarUiEvents = eventGroup({
  source: 'Modeler View Control Toolbar UI',
  events: {
    autolayoutTriggered: type<void>(),
    viewModeEnabled: type<void>(),
    viewModeDisabled: type<void>(),
    zoomLevelChanged: type<ZoomControlPayload>(),
    fitToScreenTriggered: type<ViewControlPayload>(),
    fullScreenToggled: type<ToggleViewControlPayload>(),
    shortcutsTriggered: type<void>(),
  },
});
